export const moduleName = {
  emails: 'emails',
  logging: 'logging',
  searching: 'searching',
  templates: 'templates',
  shared: 'mi_shared',
};
